/* Wubs – cookie-rutan som modal (Liam 2026-10-23).
   Shopifys egen ruta (#shopify-pc__banner, ett barn till <body>) ritas av Shopify; utseendet ligger i
   wubs-base.css. Det här skriptet gör bara det CSS inte kan:
   – låser sidan bakom med WubsScroll medan rutan är synlig (och släpper när Shopify döljer den),
   – markerar rutan som modal för hjälpmedel,
   – döljer rutan medan inställningspanelen (#shopify-pc__prefs, som har egen overlay) är öppen,
   – lägger knapparna i samma ordning som de syns (avslå · godkänn · inställningar) så att Tab följer bilden,
   – håller Tab inom rutan.
   ⚠️ Rutan skapas av Shopify EFTER sidladdning och visas/döljs med inline `display` – därför observeras
   <body> (barn) och rutan/panelen (style), inget antas om när de dyker upp. ⚠️ Esc avslår INTE: att inte
   välja är inte samma sak som att avslå. */
(function () {
  'use strict';
  var las = false;
  var obsRutor = null;

  function synlig(el) {
    return !!el && getComputedStyle(el).display !== 'none';
  }

  /* Shopify skriver ut inställningar · godkänn · avslå; CSS visar avslå · godkänn · inställningar.
     Att flytta noderna behåller deras klickhanterare. */
  function ordnaKnappar(ruta) {
    var rad = ruta.querySelector('.shopify-pc__banner__btns');
    if (!rad || rad.hasAttribute('data-wubs-ordnad')) return;
    ['decline', 'accept', 'manage-prefs'].forEach(function (namn) {
      var knapp = rad.querySelector('.shopify-pc__banner__btn-' + namn);
      if (knapp) rad.appendChild(knapp);
    });
    rad.setAttribute('data-wubs-ordnad', '');
  }

  function sync() {
    var ruta = document.getElementById('shopify-pc__banner');
    var panel = document.getElementById('shopify-pc__prefs');
    var visas = synlig(ruta);
    if (visas) {
      ordnaKnappar(ruta);
      ruta.setAttribute('aria-modal', 'true');
      if (synlig(panel)) ruta.setAttribute('data-wubs-prefs', '');
      else ruta.removeAttribute('data-wubs-prefs');
    }
    if (visas === las || !window.WubsScroll) return;
    las = visas;
    if (visas) WubsScroll.las();
    else WubsScroll.slapp();
  }

  function bevaka() {
    if (obsRutor) obsRutor.disconnect();
    obsRutor = obsRutor || new MutationObserver(sync);
    ['shopify-pc__banner', 'shopify-pc__prefs'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) obsRutor.observe(el, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    });
    sync();
  }

  new MutationObserver(bevaka).observe(document.body, { childList: true });
  bevaka();

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !las) return;
    var ruta = document.getElementById('shopify-pc__banner');
    if (!ruta || ruta.hasAttribute('data-wubs-prefs')) return;
    var mal = ruta.querySelectorAll('a[href], button:not([disabled])');
    if (!mal.length) return;
    var forsta = mal[0];
    var sista = mal[mal.length - 1];
    if (!ruta.contains(document.activeElement)) {
      e.preventDefault();
      forsta.focus();
    } else if (e.shiftKey && document.activeElement === forsta) {
      e.preventDefault();
      sista.focus();
    } else if (!e.shiftKey && document.activeElement === sista) {
      e.preventDefault();
      forsta.focus();
    }
  });
})();
